<template>
  <footer class="mt-0">
    <div class="footer-container-1 w-100" style="height: 160px">
      <div class="footer-text-1 col-6 px-3 py-3">
        <div class="footer-title mb-2">{{ footerData.owner.header }}</div>
        <div class="footer-subtitle font-weight-bold">{{ footerData.owner.name }}</div>
        <div class="footer-contact">
          <div class="pt-1">
            {{ footerData.owner.email }}
          </div>
          <div class="pt-1">{{ footerData.owner.address }}</div>
          <div class="pt-1">
            {{ footerData.owner.phone }}
          </div>
        </div>
      </div>
      <div class="footer-text-2 col-6 px-3 py-3">
        <div class="footer-title mb-2">{{ footerData.support.header }}</div>
        <div class="footer-subtitle font-weight-bold">{{ footerData.support.name }}</div>
        <div class="footer-contact">
          <div class="pt-1">
            <template v-if="footerData.support.email">
              {{ footerData.support.email }}
            </template>

            <div v-else class="support-link-wrapper">
              <button type="button" class="support-link" @click="showSupportModal = true">
                ÖFH hibabejelentés <span class="helpdesk-badge">Helpdesk</span>
              </button>
            </div>
          </div>

          <div v-if="showSupportModal" class="support-modal-backdrop">
            <div class="support-modal">
              <h3>Rendszertámogatás</h3>

              <p>
                A hibabejelentő rendszer használatához Semmelweis365 bejelentkezés
                szükséges.
              </p>

              <p>
                Ha a Helpdesk felületen belépés után nem találja közvetlenül a megfelelő
                bejelentőt, az alábbi útvonalon érhető el:
              </p>

              <div class="support-path">
                Szolgáltatások → Informatika → Szoftverek, alkalmazások → Egyetemi
                fejlesztésű alkalmazás hibabejelentés
              </div>

              <div class="support-modal-actions">
                <button type="button" @click="showSupportModal = false">Mégsem</button>

                <button type="button" @click="openHelpdesk">Helpdesk megnyitása</button>
              </div>
            </div>
          </div>
          <div class="pt-1">{{ footerData.support.address }}</div>
          <div class="pt-1">
            {{ footerData.support.phone }}
          </div>
        </div>
      </div>
    </div>

    <div
      class="footer-container-2 d-flex justify-content-between align-items-center w-100 px-3"
    >
      <div class="d-flex align-items-center gap-2">
        <span
          >© {{ getCurrentLocalYear }} Semmelweis Egyetem - Minden jog fenntartva</span
        >
        <span> v{{ appVersionText }} </span>
      </div>

      <div class="footer-menu d-flex d-flex justify-content-end">
        <ul class="m-0">
          <li class="float-start px-2">
            <a href="https://semmelweis.hu/adatvedelem" target="_blank">Adatvédelem</a>
          </li>
          <li class="footer-menu-border float-start px-2">
            <a href="https://semmelweis.hu/cookie-tajekoztato" target="_blank"
              >Cookie-tájékoztató</a
            >
          </li>
          <li class="footer-menu-border float-start px-2">
            <a href="https://semmelweis.hu/informatika/" target="_blank"
              >Informatikai Főigazgatóság honlapja</a
            >
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  /**
   * MailTo komponens:
   * Jelenleg nincs használatban ebben a footerben,
   * de a jövőben email linkekhez (mailto:) hasznos lehet.
   *
   *  Megjegyzés:❗
   * - Takács Bálint megjegyzése: a funkció jelenleg nincs ❗ℹ️ aktív használatban,
   *   azonban a jövőbeni integrációhoz előkészítve maradt a rendszerben.
   */

  data() {
    return {
      showSupportModal: false,
    };
  },

  methods: {
    openHelpdesk() {
      this.showSupportModal = false;

      window.open(
        "https://helpdesk.semmelweis.hu/Home/Index",
        "_blank",
        "noopener,noreferrer"
      );
    },

    formatPhoneNumber(value) {
      return (
        "tel:" +
        (String(value)
          .match(/[+0-9]+/g)
          ?.join("") ?? "")
      );
    },
  },

  computed: {
    appVersionText() {
      const parts = [this.appData.version];

      if (this.shortCommit) {
        parts.push(this.shortCommit);
      }

      if (this.formattedBuiltAt) {
        parts.push(this.formattedBuiltAt);
      }

      return parts.join(" • ");
    },

    shortCommit() {
      return this.appData.commit ? this.appData.commit.substring(0, 8) : null;
    },

    formattedBuiltAt() {
      return this.appData.built_at
        ? new Date(this.appData.built_at).toLocaleString()
        : null;
    },

    appData() {
      const app = window.frontendConfiguration?.vueJs?.app ?? {};
      const versionData =
        typeof app.version === "object" && app.version !== null ? app.version : app;

      return {
        version: versionData.version ?? "dev",
        commit: versionData.commit ?? "local",
        built_at: versionData.built_at ?? null,
      };
    },

    getCurrentLocalYear() {
      return new Date().getFullYear();
    },

    footerData() {
      return (
        window.frontendConfiguration?.vueJs?.footer ?? {
          owner: { header: "", name: "", email: "", address: "", phone: "" },
          support: { header: "", name: "", email: "", address: "", phone: "" },
        }
      );
    },
  },
};
</script>

<style scoped>
.footer-container-1 {
  user-select: none;
  background-color: #999;
}
.footer-container-2 {
  user-select: none;
  height: 40px;
  background-color: #707070;
  font-size: 14px;
  font-family: "Montserrat";
  color: #fff;
}
.footer-text-1,
.footer-text-2 {
  float: left;
}
.footer-text-2 {
  border-left: 2px solid #707070;
}
footer .footer-title {
  text-decoration: underline;
  font-size: 16px;
  color: #fff;
  font-family: "Montserrat";
  text-underline-offset: 5px;
}
footer .footer-subtitle,
footer .footer-contact {
  font-size: 14px;
  font-family: "Montserrat";
  color: #fff;
}
.footer-menu ul {
  list-style-type: none;
}
.footer-menu-border {
  border-left: 2px solid #fff;
}
.footer-menu ul a {
  text-decoration: none;
  color: #fff;
}
.footer-menu ul a:hover {
  text-decoration: underline;
  text-underline-offset: 4px;
}

.support-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: grid;
  place-items: center;
  background: rgba(0, 0, 0, 0.45);
}

.support-modal {
  width: 520px;
  max-width: calc(100vw - 32px);
  padding: 24px;
  background: #fff;
  color: #232f61;
  border-radius: 14px;
  box-shadow: 0 18px 45px rgba(0, 0, 0, 0.25);
}

.support-path {
  margin: 14px 0;
  padding: 12px;
  background: #f5f7fb;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  font-weight: 600;
}

.support-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.support-link-wrapper {
  position: relative;
  width: fit-content;
}

.support-link {
  padding: 0;
  margin: 0;

  border: none;
  outline: none;

  background: transparent;

  color: #fff;
  font: inherit;

  cursor: pointer;
}

.support-link:hover {
  text-decoration: none;
}

.helpdesk-badge {
  margin-left: 6px;
  padding: 2px 7px;

  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 999px;

  background: rgba(255, 255, 255, 0.12);

  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
}
</style>
